import { i18n } from '@lingui/core';

export interface EditRheologyPageParams extends Record<string, string | undefined> {
    entityId: string,
    rheologyId: string,
  }
  export const ROUTE_PARAM_IDENTIFIER = ':entityId';
  export const ROUTE_RHEOLOGY_DATA_IDENTIFIER = ':rheologyId';
  export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/rheology/edit/${ROUTE_RHEOLOGY_DATA_IDENTIFIER}`;
  export const TITLE = i18n._('Edit Rheology');
